import { render, staticRenderFns } from "./AssignmentModal.vue?vue&type=template&id=420e68c5&scoped=true&"
import script from "./AssignmentModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentModal.vue?vue&type=style&index=0&id=420e68c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420e68c5",
  null
  
)

export default component.exports